module.exports = __webpack_public_path__ + "img/tintuc22.d823383d.png";